import React from 'react'

export default function BreakOnNewline ({ text }) {
  const pieces = []
  let i = 0
  ;(text || '').split('\n').forEach(piece => {
    if (pieces.length > 0) {
      pieces.push(<br key={`break-${i}`} />)
    }
    pieces.push(<span key={`text-${i}`}>{piece.trim()}</span>)
    i += 1
  })

  return <span>{pieces}</span>
}
